$(document).ready(() => {
    const mqTablet = window.matchMedia("(max-width: 1024px)")
    const mqMobile = window.matchMedia("(max-width: 768px)")
    const mqMobileSmall = window.matchMedia("(max-width: 400px)")
    const isSlickLoaded = (typeof $.fn.slick !== 'undefined')

        // NAV
        ; (() => {
            const
                scrollTopOffset = 1,

                $menuToggle = document.querySelector(".c-nav .c-nav__mobile-menu-toggle"),
                $menu = document.querySelector(".c-nav .c-nav__menu"),
                $nav = document.querySelector(".c-nav"),

                classOn = "c-nav__mobile-menu-toggle--active",
                classOff = "c-nav__mobile-menu-toggle--not-active",
                classNoScroll = "u-no-scroll",
                classMenuOn = "c-nav__menu--active",
                classNavActive = "c-nav--active"

            const getScroll = () => {
                const doc = document.documentElement
                const left = (window.pageXOffset || doc.scrollLeft) - (doc.clientLeft || 0)
                const top = (window.pageYOffset || doc.scrollTop) - (doc.clientTop || 0)

                return { top, left }
            }

            $menuToggle.addEventListener("click", e => {
                e.preventDefault()
                if ($menuToggle.classList.contains(classOn)) {
                    $menuToggle.classList.remove(classOn)
                    $menuToggle.classList.add(classOff)
                    $menu.classList.remove(classMenuOn)
                    if (getScroll().top <= scrollTopOffset) {
                        $nav.classList.remove(classNavActive)
                    }
                    if (!document.querySelector(".c-contact-form--popup")) {
                        document.querySelectorAll("html, body").forEach(el => {
                            el.classList.remove(classNoScroll)
                        })
                    }
                } else {
                    $menuToggle.classList.add(classOn)
                    $menuToggle.classList.remove(classOff)
                    $menu.classList.add(classMenuOn)
                    $nav.classList.add(classNavActive)
                    document.querySelectorAll("html, body").forEach(el => {
                        el.classList.add(classNoScroll)
                    })
                }
            })

            if (document.body.classList.contains("home")) {
                const onScroll = () => {
                    if (getScroll().top > scrollTopOffset) {
                        $nav.classList.add(classNavActive)
                    } else {
                        $nav.classList.remove(classNavActive)
                    }
                }
                window.addEventListener("scroll", onScroll)
                onScroll()
            }

            let scrollTop = getScroll().top
            const hideClass = "c-nav--hide"
            window.addEventListener("scroll", _.throttle(e => {
                const actualScrollTop = getScroll().top
                if (actualScrollTop > scrollTop && actualScrollTop > $nav.clientHeight) {
                    $nav.classList.add(hideClass)
                } else {
                    $nav.classList.remove(hideClass)
                }
                scrollTop = actualScrollTop
            }, 250))
        })()

        // NAV HOVER
        ; (() => {
            if (!mqTablet.matches) {
                const
                    $hover = document.querySelector(".c-nav__menu-item--hover"),
                    $menu = document.querySelector(".c-nav"),
                    $links = document.querySelectorAll(".c-nav__menu-link"),
                    animationDuration = 750

                let $activeItem = document.querySelector(".c-nav__menu-item--active")

                if (!$activeItem)
                    $activeItem = document.querySelector(".c-nav__menu-item--null")

                const easeInOutSine = x => -(Math.cos(Math.PI * x) - 1) / 2

                const animate = ($hover, $link, duration = animationDuration) => {
                    $hover.style.display = "block"

                    let start
                    const step = timestamp => {
                        if (start === undefined)
                            start = timestamp
                        const elapsed = timestamp - start
                        const end = start + duration

                        const getProperty = (hoverProperty, linkProperty) =>
                        (parseInt($hover.style[hoverProperty]) + ((parseInt($link[linkProperty]) - parseInt($hover.style[hoverProperty])) *
                            easeInOutSine(elapsed / duration)))

                        $hover.style.left = getProperty("left", "offsetLeft") + "px"
                        $hover.style.width = getProperty("width", "clientWidth") + "px"

                        if (elapsed < duration) {
                            window.requestAnimationFrame(step)
                        } else {
                            $hover.style.left = $link.offsetLeft + "px"
                            $hover.style.width = $link.clientWidth + "px"
                        }
                    }
                    window.requestAnimationFrame(step)
                }

                animate($hover, $activeItem, 0)

                $links.forEach($link => {
                    $link.addEventListener("mouseenter", () => {
                        animate($hover, $link)
                    })
                })

                $menu.addEventListener("mouseleave", () => {
                    animate($hover, $activeItem)
                })

                window.addEventListener("resize", () => {
                    animate($hover, $activeItem, 0)
                })
            }
        })()

        // FAQ
        ; (() => {
            if (window.gsap) {
                const classActive = "c-faq__list-item--active"
                document.querySelectorAll(".c-faq__list-item").forEach(function ($item) {
                    const $link = $item.querySelector(".c-faq__list-link")
                    const $content = $item.querySelector(".c-faq__list-content")
                    $link.addEventListener("click", e => {
                        e.preventDefault()
                        if ($item.classList.contains(classActive)) {
                            gsap.to($content, {
                                duration: .5, opacity: 0, height: 0, ease: "power2.inOut", onComplete: () => {
                                    $item.classList.remove(classActive)
                                    gsap.set($content, { height: "auto" })
                                }
                            })
                        } else {
                            $item.classList.add(classActive)
                            const contentHeight = $content.clientHeight
                            gsap.set($content, { opacity: 0, height: 0 })
                            gsap.to($content, { duration: .5, opacity: 1, height: contentHeight, ease: "power2.inOut" })
                        }
                    })
                })
            }
        })()

        // READ MORE
        ; (() => {
            if (window.gsap) {
                const $readMoreBlocks = document.querySelectorAll(".js-read-more-block")
                $readMoreBlocks.forEach($block => {
                    const $link = $block.querySelector(".js-link-more")
                    if ($link) {
                        const $content = $block.querySelector(".js-content-more")
                        const classRoot = $link.getAttribute("data-class-root")
                        $link.addEventListener("click", e => {
                            e.preventDefault()
                            $link.classList.add(`${classRoot}__more-link--hide`)
                            $content.classList.add(`${classRoot}__more-content--show`)
                            gsap.from($content, { duration: .5, opacity: 0, height: 0, ease: "power2.inOut" });
                        })
                    }
                })
            }
        })()

        // VYSTAVBA SLIDESHOW
        ; (() => {
            if (isSlickLoaded) {
                const $slick = $(".c-vystavba-slideshow__slideshow")
                const $arrLeft = $(".c-vystavba-slideshow__arr--left")
                const $arrRight = $(".c-vystavba-slideshow__arr--right")
                const inactiveClass = "c-vystavba-slideshow__arr--inactive"
                $slick.slick({
                    arrows: false,
                    dots: false,
                    speed: 300,
                    slidesToShow: 1,
                    infinite: false,
                })
                $(".c-vystavba-slideshow__arr--left").click(e => {
                    e.preventDefault()
                    $slick.slick("slickPrev")
                })
                $(".c-vystavba-slideshow__arr--right").click(e => {
                    e.preventDefault()
                    $slick.slick("slickNext")
                })
                $slick.on('afterChange', function (event, slick, currentSlide) {
                    if (currentSlide == 0) {
                        $arrLeft.addClass(inactiveClass)
                        $arrRight.removeClass(inactiveClass)
                    } else if (currentSlide == slick.slideCount - 1) {
                        $arrRight.addClass(inactiveClass)
                        $arrLeft.removeClass(inactiveClass)
                    } else {
                        $arrRight.removeClass(inactiveClass)
                        $arrLeft.removeClass(inactiveClass)
                    }
                });
            }
        })()

        // VYSTAVBA PODILENI SE SLIDESHOW
        ; (() => {
            if (isSlickLoaded) {
                const $slick = $(".c-vystavba-podileni__slideshow")
                const $arrLeft = $(".c-vystavba-podileni__arr--left")
                const $arrRight = $(".c-vystavba-podileni__arr--right")
                const inactiveClass = "c-vystavba-podileni__arr--inactive"
                const mqBreakpoint = window.matchMedia("(max-width: 1250px)").matches
                let slidesToShow = 3
                const mql = window.matchMedia("(max-width: 1250px")
                if (mql.matches) slidesToShow = 1
                mql.addEventListener('change', e => {
                    if (e.matches)
                        slidesToShow = 1
                    else
                        slidesToShow = 3
                });
                $slick.slick({
                    arrows: false,
                    dots: false,
                    speed: 300,
                    slidesToShow: slidesToShow,
                    variableWidth: true,
                    infinite: false,
                    responsive: [
                        {
                            breakpoint: 1250,
                            settings: {
                                slidesToShow: 1,
                            },
                        },
                    ]
                })
                $(".c-vystavba-podileni__arr--left").click(e => {
                    e.preventDefault()
                    $slick.slick("slickPrev")
                })
                $(".c-vystavba-podileni__arr--right").click(e => {
                    e.preventDefault()
                    $slick.slick("slickNext")
                })
                $slick.on('afterChange', function (event, slick, currentSlide) {
                    if (currentSlide == 0) {
                        $arrLeft.addClass(inactiveClass)
                        $arrRight.removeClass(inactiveClass)
                    } else if (currentSlide == Math.ceil(slick.slideCount / slidesToShow) - mqBreakpoint ? 1 : 0) {
                        $arrRight.addClass(inactiveClass)
                        $arrLeft.removeClass(inactiveClass)
                    } else {
                        $arrRight.removeClass(inactiveClass)
                        $arrLeft.removeClass(inactiveClass)
                    }
                });
            }
        })()

        // HASH SCROLL
        ; (() => {
            const getElementPageOffset = $el => {
                const bodyRect = document.body.getBoundingClientRect(),
                    elemRect = $el.getBoundingClientRect(),
                    offset = elemRect.top - bodyRect.top - document.querySelector(".c-nav").clientHeight - 25
                return offset
            }

            if (window.location.hash) {
                const selector = `[data-anchor="${window.location.hash.substring(1)}"]`
                const $scrollTo = document.querySelector(selector)
                if ($scrollTo) {
                    const offset = getElementPageOffset($scrollTo)
                    $("html, body").animate({ scrollTop: offset }, 1000, "swing")
                }
            }

            document.querySelectorAll('a[href*="#"]').forEach($link => {
                const hash = $link.getAttribute("href").split("#")[1]
                const selector = `[data-anchor="${hash}"]`
                const $scrollTo = document.querySelector(selector)
                if ($scrollTo) {
                    $link.addEventListener("click", e => {
                        e.preventDefault()
                        const offset = getElementPageOffset($scrollTo)
                        $("html, body").animate({ scrollTop: offset }, 1000, "swing")
                    })
                }
            })
        })()


        // WPCF7 FROM SUBMIT

        ; (() => {
            document.addEventListener('wpcf7mailsent', () => {
                const $contactForm = document.querySelector(".c-contact-form")
                if($contactForm) {
                    document.querySelectorAll(".c-contact-form").forEach($form => {
                        $form.classList.add("c-contact-form--sent")
                        if(ga) {
                            if($form.classList.contains("c-contact-form--inquiry")) {
                                ga('send', 'event', 'form', 'submit', 'poptavka')
                            } else {
                                ga('send', 'event', 'form', 'submit', 'dotaz')
                            }
                        }
                    })
                }
            })
        })()
})
